
export function Whatsapp() {
    return (
        <div>
            <a href="https://wa.me/573167775380?text=Me%20gustaría%20hacer%20parte%20de%20Broncos%20Bello" class="whatsapp" target="_blank">
                <i class="fa fa-whatsapp whatsapp-icon"></i>
            </a>
        </div>
    );
}